import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { SlidersComponent } from './sliders/sliders.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProjectsComponent } from './projects/projects.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import { ServiceprovideComponent } from './serviceprovide/serviceprovide.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { CertificationComponent } from './certification/certification.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { CallmeComponent } from './callme/callme.component';


@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        SlidersComponent,
        ProjectsComponent,
        ServiceprovideComponent,
        AboutUsComponent,
        CertificationComponent,
        FooterComponent,
        CallmeComponent,
        
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgbModule, MatDialogModule, MatButtonModule, RouterModule.forRoot([
            { path: 'aboutus', component: AboutUsComponent },
            { path: 'Home', component: HeaderComponent },
            { path: 'project', component: ProjectsComponent },
            { path: 'contact', component: CallmeComponent },
        ]),
        BrowserAnimationsModule, MatToolbarModule,
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
